import { Stack } from '@mui/material';
import { useState } from 'react';
import VegaPageHeader from '../../components/common/VegaPageHeader';
import VegaTabBar from '../../components/common/VegaTabBar';
import VegaTabBarItem from '../../components/common/VegaTabItem';
import VegaText from '../../components/common/VegaText';
import { toLowerCase } from '../../constants/commonFunction';
import ListOfReceiptsAgent from './module/ListOfReceiptsAgent';
import ListOfAccountsAgent from './module/ListOfAccountsAgent';

export enum TabType {
  ACCOUNTS = 'ACCOUNTS',
  RECEIPTS = 'RECEIPTS',
}

const ReceiptAgent = () => {
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const onTabChange = (value: number) => {
    setSelectedTab(value);
  };

  return (
    <>
      <VegaPageHeader
        renderLeftView={() => {
          return (
            <Stack spacing={'2rem'}>
              <VegaText
                text={'Receipt Management'}
                fontWeight={600}
                fontSize={'1.0625rem'}
                color={'black'}
              />
              <VegaTabBar
                value={selectedTab}
                onChange={(e, selected) => {
                  onTabChange(selected);
                }}
              >
                <VegaTabBarItem label={toLowerCase(TabType.ACCOUNTS)} />
                <VegaTabBarItem label={toLowerCase(TabType.RECEIPTS)} />
              </VegaTabBar>
            </Stack>
          );
        }}
      />
      {selectedTab === 1 ? <ListOfReceiptsAgent /> : <ListOfAccountsAgent />}
    </>
  );
};

export default ReceiptAgent;
